import {Injectable} from '@angular/core';
import {Match} from '../model/events/Match';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class MatchResultService
{
  public isFinished(match: Match): boolean
  {
    const hasSets = this.hasSets(match);
    if (hasSets)
    {
      return match.setsHome > 0 || match.setsAway > 0;
    }
    else
    {
      return match.legsHome > 0 || match.legsAway > 0;
    }
  }

  public isWinnerHome(match: Match): boolean
  {
    const hasSets = this.hasSets(match);
    if (hasSets)
      return (match.setsHome > 0 || match.setsAway > 0) && (match.setsHome > match.setsAway);
    else return (match.legsHome > 0 || match.legsAway > 0) && (match.legsHome > match.legsAway);
  }

  public isWinnerAway(match: Match): boolean
  {
    const hasSets = this.hasSets(match);
    if (hasSets)
      return (match.setsHome > 0 || match.setsAway > 0) && (match.setsHome < match.setsAway);
    else return (match.legsHome > 0 || match.legsAway > 0) && (match.legsHome < match.legsAway);
  }

  public isTie(match: Match): boolean
  {
    const hasSets = this.hasSets(match);
    if (hasSets)
      return (match.setsHome > 0 || match.setsAway > 0) && (match.setsHome === match.setsAway);
    else return (match.legsHome > 0 || match.legsAway > 0) && (match.legsHome === match.legsAway);
  }

  private hasSets(match: Match): boolean
  {
    return match.setsHome > 0 || match.setsAway > 0;
  }
}
